import React, { Component } from "react";
import "./DeletePostModal.scss";
import Modal from "../../../../components/UIComponents/CustomModal/Modal";

export default class DeletePostModal extends Component {
    render() {
        let postUrl = "";
        if (Object.keys(this.props.fbPOstUrlToBeDeleted ?? []).length !== 0) {
            postUrl = this.props.fbPOstUrlToBeDeleted.post_url;
        }
        return (
            <div>
                <Modal className={`delete-facebookPost`} show={this.props.open} onClose={this.props.onClose}>
                    <Modal.Header>Delete Post Url</Modal.Header>
                    <Modal.Content className="delete-facebookPost-content">
                        <p>
                            Are you sure you want to delete <span className="facebookPost-to-be-deleted">{postUrl && postUrl}</span> from Facebook Post URL
                            list? You will not be able to recover them.
                        </p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Modal.ActionButton normal onClick={this.props.onClose}>
                            Cancel
                        </Modal.ActionButton>
                        <Modal.ActionButton filled onClick={() => this.props.delete(this.props.fbPOstUrlToBeDeleted)}>
                            Delete
                        </Modal.ActionButton>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}
